export const COVER_FONT_SIZE_DEFAULT = 72;
export const WATERMARK_FONT_SIZE_DEFAULT = 28;

export const COVER_FONT_SIZE_OPTIONS = [
  { value: 48, label: '小 (48)' },
  { value: 60, label: '较小 (60)' },
  { value: 72, label: '标准 (72)' },
  { value: 84, label: '较大 (84)' },
  { value: 96, label: '大 (96)' },
];

export const WATERMARK_FONT_SIZE_OPTIONS = [
  { value: 20, label: '小 (20)' },
  { value: 28, label: '标准 (28)' },
  { value: 36, label: '较大 (36)' },
  { value: 48, label: '大 (48)' },
];
